// extracted by mini-css-extract-plugin
export default {"about":"AboutUs_about__CtNDw"};